export default __webpack_public_path__ + "static/media/jingle-bell.26bc50fb.mp3";